import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheckIcon, XIcon, LockIcon } from 'lucide-react';
const TRUE_TOTAL = 1070;
const BUNDLE_PRICE = 749;
const DISCOUNT_PCT = 30;
const FULL_BUNDLE_URL = 'https://www.alivionaturalshop.com/cart/51525390664001:1';
const MAIN_ONLY_URL = 'https://www.alivionaturalshop.com/cart/51513616499009:1';
interface ExitUpsellPopupProps {
  isOpen: boolean;
  onClose: () => void;
}
export function ExitUpsellPopup({
  isOpen,
  onClose
}: ExitUpsellPopupProps) {
  const handleAccept = () => {
    window.open(FULL_BUNDLE_URL, '_blank', 'noopener,noreferrer');
    onClose();
  };
  const handleDecline = () => {
    window.open(MAIN_ONLY_URL, '_blank', 'noopener,noreferrer');
    onClose();
  };
  return <AnimatePresence data-id="element-9">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} onClick={onClose} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[9990]" data-id="element-10" />

          <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 40
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.9,
        y: 40
      }} transition={{
        duration: 0.35,
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="fixed inset-0 z-[9995] flex items-center justify-center p-3 pointer-events-none" data-id="element-11">
            <div className="pointer-events-auto bg-white rounded-2xl shadow-2xl max-w-[420px] w-full max-h-[95vh] overflow-y-auto relative" data-id="element-12">
              {/* Close */}
              <button onClick={onClose} className="absolute top-2.5 right-2.5 w-7 h-7 flex items-center justify-center rounded-full bg-white/80 hover:bg-gray-200 transition-colors z-10" aria-label="Cerrar" data-id="element-13">
                <XIcon className="w-3.5 h-3.5 text-gray-500" data-id="element-14" />
              </button>

              {/* ── HEADER ── */}
              <div className="bg-gradient-to-r from-red-600 to-red-500 text-white text-center py-2.5 px-4 rounded-t-2xl" data-id="element-15">
                <p className="text-[9px] uppercase tracking-widest font-bold animate-pulse mb-0.5" data-id="element-16">
                  ⚠️ Oferta única — No volverás a ver este precio
                </p>
                <h3 className="text-base font-serif font-bold leading-tight" data-id="element-17">
                  🛑 ¡Espera! No te vayas sin esto...
                </h3>
              </div>

              {/* ── BODY ── */}
              <div className="px-4 py-3 space-y-3" data-id="element-18">
                {/* Discount badge */}
                <div className="flex justify-center" data-id="element-19">
                  <span className="inline-block bg-red-500 text-white font-bold text-xs px-3 py-1 rounded-full shadow-lg animate-bounce-gentle" data-id="element-20">
                    🔥 {DISCOUNT_PCT}% en el precio final con todos los extras
                    incluidos
                  </span>
                </div>

                {/* Copy */}
                <p className="text-xs text-gray-700 text-center leading-relaxed" data-id="element-21">
                  Llévate el <strong data-id="element-22">paquete completo</strong> para transformar
                  tu salud en 30 días con los 300 remedios naturales
                  <em data-id="element-23"> y las herramientas que aceleran tus resultados.</em>
                </p>

                {/* ── WHAT'S INCLUDED ── */}
                <div className="bg-ancestral-green rounded-xl p-3 space-y-1.5" data-id="element-24">
                  <p className="text-[10px] font-bold text-ancestral-gold uppercase tracking-wider text-center mb-1" data-id="element-25">
                    ⚡ Lo que te llevas HOY con el paquete completo
                  </p>

                  {[{
                icon: '📖',
                name: 'El Gran Recetario Ancestral',
                detail: '300 remedios naturales'
              }, {
                icon: '🎁',
                name: '10 Bonos de Regalo',
                detail: 'Hierbas, tés, detox, aceites y más'
              }, {
                icon: '🚀',
                name: 'Protocolo de 7 Días',
                detail: 'Calendario paso a paso'
              }, {
                icon: '🛡️',
                name: 'Guía de Seguridad',
                detail: 'Interacciones y dosis seguras'
              }].map((item, i) => <div key={i} className="flex items-center gap-2 bg-white/10 rounded-lg px-2.5 py-1.5" data-id="element-26">
                      <span className="text-sm flex-shrink-0" data-id="element-27">{item.icon}</span>
                      <div className="min-w-0" data-id="element-28">
                        <p className="text-[11px] font-bold text-ancestral-cream leading-tight" data-id="element-29">
                          {item.name}
                        </p>
                        <p className="text-[9px] text-ancestral-cream/60" data-id="element-30">
                          {item.detail}
                        </p>
                      </div>
                      <span className="text-emerald-400 text-[10px] font-bold flex-shrink-0 ml-auto" data-id="element-31">
                        ✓
                      </span>
                    </div>)}
                </div>

                {/* ── PRICING ── */}
                <div className="bg-amber-50 border border-ancestral-gold/30 rounded-xl p-3 text-center" data-id="element-32">
                  <div className="flex items-center justify-center gap-2 mb-0.5" data-id="element-33">
                    <span className="text-xs text-gray-400 line-through" data-id="element-34">
                      ${TRUE_TOTAL.toLocaleString()} UYU
                    </span>
                    <span className="text-[8px] bg-red-500 text-white px-1.5 py-0.5 rounded font-bold" data-id="element-35">
                      -{DISCOUNT_PCT}%
                    </span>
                  </div>
                  <div className="flex items-baseline justify-center gap-1" data-id="element-36">
                    <span className="text-3xl font-serif font-bold text-ancestral-green" data-id="element-37">
                      ${BUNDLE_PRICE}
                    </span>
                    <span className="text-sm font-bold text-ancestral-green" data-id="element-38">
                      UYU
                    </span>
                  </div>
                  <div className="flex items-center justify-center gap-1 mt-1" data-id="element-39">
                    <LockIcon className="w-3 h-3 text-ancestral-gold" data-id="element-40" />
                    <span className="text-[9px] text-gray-500 italic" data-id="element-41">
                      Precio especial solo en esta pantalla
                    </span>
                  </div>
                  <div className="flex items-center justify-center gap-1 mt-1" data-id="element-42">
                    <ShieldCheckIcon className="w-3 h-3 text-emerald-500" data-id="element-43" />
                    <span className="text-[9px] text-gray-500 font-medium" data-id="element-44">
                      Garantía 60 días · Pago seguro
                    </span>
                  </div>
                </div>

                {/* ── CTAs ── */}
                <div className="space-y-2" data-id="element-45">
                  <button onClick={handleAccept} className="w-full bg-emerald-500 hover:bg-emerald-400 text-white border-2 border-emerald-400 rounded-xl py-3 px-4 shadow-lg hover:shadow-xl transition-all duration-300 relative overflow-hidden" data-id="element-46">
                    <span className="absolute inset-0 bg-white/20 rounded-xl animate-ping-slow pointer-events-none" data-id="element-47" />
                    <span className="relative font-serif font-bold text-sm text-center uppercase tracking-wide block" data-id="element-48">
                      ¡SÍ! Quiero el Paquete Completo por ${BUNDLE_PRICE} →
                    </span>
                  </button>

                  <button onClick={handleDecline} className="w-full text-center py-1.5 text-[11px] text-gray-400 hover:text-gray-600 transition-colors underline underline-offset-2" data-id="element-49">
                    No gracias, continuar sin los extras →
                  </button>
                </div>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}